// extracted by mini-css-extract-plugin
export default {"card":"Faq-Card_card__b01bK","title":"Faq-Card_title__42XZf","content":"Faq-Card_content__ZK9T5","dark":"Faq-Card_dark__42g+w"};